import { DropdownMenu } from 'radix-ui'
import type { ReactNode } from 'react'
import { Actions } from '../../../cars/components/V3/icons/Actions'

export type DropdownItems = {
  label: string
  onSelect: () => void
  icon?: ReactNode
  disabled?: boolean
}

type GenericDropdownProps = {
  items: DropdownItems[]
  ariaLabel?: string
  trigger?: ReactNode
}

export const GenericDropdown = ({ items, ariaLabel = 'Åpne meny', trigger }: GenericDropdownProps) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        {trigger ?? (
          <button type="button" aria-label={ariaLabel}>
            <Actions />
          </button>
        )}
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          side="bottom"
          align="end"
          sideOffset={4}
          className="min-w-[160px] rounded-md border border-borderGray bg-white shadow-md p-1 text-sm"
        >
          {items.map((item, index) => (
            <DropdownMenu.Item
              key={index}
              disabled={item.disabled}
              onSelect={item.onSelect}
              className={[
                'cursor-pointer rounded-sm px-3 py-3 hover:bg-blueDark hover:font-bold hover:text-secondaryBlue outline-none data-[disabled]:bg-grayDrark data-[disabled]:text-disabledText data-[disabled]:cursor-default',
              ].join(' ')}
            >
              <div className="flex items-center gap-3">
                {item.icon && <div>{item.icon}</div>}
                <div>{item.label}</div>
              </div>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
